export default __webpack_public_path__ + "static/media/welding.3a60ca21.webp";